<ng-container *ngFor="let passengerFormGroup of passengerFormGroups; let i = index; let first = first; let last = last">
  <fin-passenger-info-renewed
    *ngIf="extendedPassengers$ | async as extendedPassengers"
    [passengerFormGroup]="passengerFormGroup"
    [extendedPassenger]="extendedPassengers[i]"
    [availableDays]="availableDays[i]"
    [allFrequentFlyerCards$]="allFrequentFlyerCards$"
    [profileType$]="profileType$"
    [showEdit]="showEdit"
    [controlData$]="controlData$"
    [isMainPax]="i === 0"
    [isSaving$]="isSaving$"
    [paxIndex]="i + 1"
    [ngClass]="{
      'pr-small-b': first,
      'pr-small-y': !first,
      'border-bottom-dashed': !last
    }"
    (handleSave)="handleSave($event)"
  ></fin-passenger-info-renewed>
</ng-container>
